import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* providers */
import { LojaModelService } from './loja.model.service';
import { VitrineModelService } from './vitrine.model.service';
import { ConsumidorSiteClientModelService } from './consumidorsiteclient.model.service';
import { ZoopModelService } from './zoop.model.service';
import { LiquidacaoParcelaModelService } from './liquidacaoparcela.model.service';
import { PagamentoPIXModelService } from './pagamentopix.model.service';
import { ParametrosModelService } from './parametros.model.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    LojaModelService,
    VitrineModelService,
    ConsumidorSiteClientModelService,
    ZoopModelService,
    LiquidacaoParcelaModelService,
    PagamentoPIXModelService,
    ParametrosModelService
  ]
})
export class ModelServiceModule { }
